module.exports = __webpack_public_path__ + "images/cb1b4c1a48689997807d6ba0112b5d47.svg";